<template>
  <div class="box">
    <el-card class="box-card" body-style="margin: 0;padding: 0;height: 100%;width: 100%;">
        <iframe class="_iframe" ref="coummunityIframe" :src="url" id="map" scrolling="no" frameborder="0" ></iframe>
    </el-card>
    <el-drawer
      :visible.sync="dialog"
      :before-close="drawerClosed"
      size="600px"
      direction="ltr"
      custom-class="demo-drawer"
      ref="drawer"
      >
      <div class="demo-drawer__content demo-drawer-community">
        <el-form :model="form" :rules="rules" class="demo-dynamic">
          <el-form-item prop="content">
            <el-input type="textarea" v-model="form.content" placeholder="这一刻的想法"></el-input>
          </el-form-item>
          <el-form-item >
            <el-upload
              :action="`${communityUrl}/dynamic/upload`"
              ref="upload"
              list-type="picture-card"
              name="file"
              :limit="9"
              :auto-upload="false"
              :on-exceed="imgExceed"
              :on-change="imgChange"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :headers="headers"
              :disabled="disabled"
              accept=".jpg,.jpeg,.png,.JPG,.JPEG"
              >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="种草课程:">
            <el-select v-model="form.courseId" filterable placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="addDynamic" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
        </div>
      </div>
    </el-drawer>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
  import {getCookie} from '../../untils/common.js'
  import {ApiGetCourse, ApiAddDynamic} from '../../net/community/index.js'
  import {ApiPointsOrder} from '../../net/home/index.js'
  import config from "../../net/config";
  export default {
    data: function () {
      return {
        user: {},
        url: ``,
        communityUrl: config.communityUrl,
        communityUrl2: config.communityUrl2,
        dialog: false,
        loading: false,
        formLabelWidth: '80px',
        form: {
          topicId: 0,
          courseId: '',
          content: '',
          file: '',
          code: ''
        },
        dialogImageUrl: '',
        dialogVisible: false,
        disabled: false, // 是否禁用文件选择
        options: [],
        headers: {
          'Content-Type': 'multipart/form-data',
          'appid': 510000001,
          'UserOnlyId': 0,
          'AppVersion': '1.0.0',
          'PhoneModel': 'PC-student',
          'OsVersion': '1.0.0',
          'DeviceToken': '0',
          'Bearer': getCookie('token') || '',
          "LoginType": 0,
        },
        rules: {
          content: [
            { required: false, message: '内容不能为空', trigger: 'blur' },
            { max: 300, message: '长度超出限制', trigger: 'blur' }
          ],
        }
      }
    },
    methods: {
      toPublish: function (data){
        if(data.page != 'community' || !data.topicId) {return}
        this.form.topicId = data.topicId
        this.dialog = true
      },
      cancelForm: function (){
        this.loading = false;
        this.dialog = false;
        this.clearData()
      },
      getCourse: function () {
        const pramas = {
          key: '',
          pageNum: 1,
          pageSize: 1000
        }
        ApiGetCourse(pramas).then(res=>{
          if (res.code == 200) {
            this.options = res.value
          }

        })
      },
      isImage(fileName) {
        if (typeof fileName !== 'string') return;
        let name = fileName.toLowerCase();
        return name.endsWith('.png') || name.endsWith('.jpeg') || name.endsWith('.jpg') || name.endsWith('.png') || name.endsWith('.bmp');
      },
      changeBtnShow() {
        if (this.$refs.upload.uploadFiles.length>0) {
          const _file = this.$refs.upload.uploadFiles[this.$refs.upload.uploadFiles.length - 1]
          let type = this.isImage(_file.name);
          if (!type) {
            this.$refs.upload.uploadFiles.pop()
            this.$message.error('只允许上传图片')
          }

        }

        // let btn = document.querySelector('.el-upload--picture-card')
        // if (this.$refs.upload.uploadFiles.length >= 9) {
        //   btn.style.display = 'none'
        // } else {
        //   setTimeout(function () {
        //      btn.style.display = 'inline-block'
        //   },500)
        // }
      },
      addDynamic: function () {
        if (this.$refs.upload.uploadFiles.length == 0) {
          this.$message.warning('请选择图片后发布')
          return
        }

        const uploadFileList = this.$refs.upload.uploadFiles.map(item=>{
          return item.raw
        })
        var formData = new FormData()
        formData.append("content", this.form.content)
        formData.append("topicId", this.form.topicId)
        formData.append("courseId", this.form.courseId)
        uploadFileList.forEach(item=>{
        	formData.append("file", item)
        })
        const _url = `${this.communityUrl}/dynamic/addDynamic`
        this.loading = true
				this.axios2.post(_url, formData, {headers: this.headers}).then((res)=>{
          this.loading = false
          this.dialog = false
          this.clearData()
          this.pointsOrder(13)
          this.$refs.coummunityIframe.contentWindow.postMessage({page: 'community', type: 'close'}, '*')
				}).catch(err=>{
					console.log('上传失败',err)
          this.loading = false
				})
      },
      pointsOrder: function (id) {
        const pramas = {
          orderType: 0,
          detailId: id
        }
        ApiPointsOrder(pramas).then(res=>{
          console.log('res')
        })
      },
      handleRemove(file, fileList) {
        // console.log(file, fileList);
        //this.changeBtnShow()
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      imgExceed: function (files, fileList) {
        this.$message.warning('最多只能上传9张图片哦')
      },
      imgChange(file, fileList) {
        this.changeBtnShow()
      },
      clearData: function () {
        this.form.content = ''
        this.form.courseId = ''
        this.$refs.upload.clearFiles()
       // this.changeBtnShow()
      },
      drawerClosed: function (done) {
        this.clearData()
        done()
      }
    },
    created() {

      // window.addEventListener('message', (event) => {
      //   this.toPublish(event.data)
      // }, false)
      window.onmessage = (event) => {
        // console.log(event)
        this.toPublish(event.data)
      }
    },
    mounted: function () {
      this.user =JSON.parse(getCookie('user'))
      this.url=`${this.communityUrl2}/studyBBSPC/index.html#/topicHome?uid=${this.user.uid}&token=${this.user.token}&name=${this.user.realName}&ver=1628218477194585.0`
      console.log(this.url)
      this.getCourse()
    }
  }
</script>
<style type="text/css">
  .demo-drawer-community .el-upload-list--picture-card .el-upload-list__item{
    width: 130px;
    height: 130px;
  }
  .demo-drawer-community .el-upload--picture-card{
    width: 130px;
    height: 130px;
    line-height: 130px;
  }
</style>
<style scoped>
  .box{
    height: calc(100vh - 80px);
  }
  .box-card{
    width: 1140px;
    height: calc(100vh - 100px);
    position: absolute;
    left: 50%;
    top: 100px;
    margin-left: -570px;
    background: #fff;
  }
  ._iframe{
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
  }
.demo-drawer__content{
  width: 80%;
  margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// src/components/Community/Community.vue